module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/landing/cloud-cb81a9936e07dc9a34af768dd021033f.jpg";